import { NavLink, Outlet } from "react-router-dom";
import { Megaphone, LayoutGrid, Palette, Tag, Rocket, ListChecks, BookOpen, Inbox, Image, MonitorCheck, Settings2, CalendarDays, Send, BarChart3, Wand2 } from "lucide-react";

const TABS = [
  { to: "/marketing", label: "Overview", icon: LayoutGrid, end: true, testid: "mkt-nav-overview" },
  { to: "/marketing/approval-inbox", label: "Approval Inbox", icon: Inbox, testid: "mkt-nav-inbox" },
  { to: "/marketing/media-review", label: "Media Review", icon: MonitorCheck, testid: "mkt-nav-media-review" },
  { to: "/marketing/calendar", label: "Calendar", icon: CalendarDays, testid: "mkt-nav-calendar" },
  { to: "/marketing/publishing", label: "Publishing", icon: Send, testid: "mkt-nav-publishing" },
  { to: "/marketing/publishing-report", label: "Publishing Report", icon: BarChart3, testid: "mkt-nav-report" },
  { to: "/marketing/brand-profile", label: "Brand Profile", icon: Palette, testid: "mkt-nav-brand" },
  { to: "/marketing/media-settings", label: "Media Settings", icon: Wand2, testid: "mkt-nav-media-settings" },
  { to: "/marketing/brand-assets", label: "Brand Assets", icon: Image, testid: "mkt-nav-assets" },
  { to: "/marketing/knowledge-base", label: "Knowledge Base", icon: BookOpen, testid: "mkt-nav-kb" },
  { to: "/marketing/offers", label: "Offers", icon: Tag, testid: "mkt-nav-offers" },
  { to: "/marketing/campaigns", label: "Campaigns", icon: Rocket, testid: "mkt-nav-campaigns" },
  { to: "/marketing/content", label: "Content Queue", icon: ListChecks, testid: "mkt-nav-content" },
  { to: "/marketing/operations", label: "Operations", icon: Settings2, testid: "mkt-nav-operations" },
];

export default function MarketingLayout() {
  return (
    <div className="max-w-7xl" data-testid="marketing-command-center">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-[#581C87] to-[#7C3AED] flex items-center justify-center text-white">
          <Megaphone className="h-5 w-5" />
        </div>
        <div>
          <p className="text-xs uppercase tracking-widest text-[#581C87] font-semibold">
            Shared Service
          </p>
          <h1 className="font-heading text-2xl md:text-3xl font-bold tracking-tight">
            Marketing Command Center
          </h1>
        </div>
        <span className="ml-auto hidden sm:inline-flex items-center rounded-full bg-[#F3E8FF] px-3 py-1 text-xs font-semibold text-[#6B21A8]">
          Phase 2 · KISSED University Pilot
        </span>
      </div>

      <div className="mt-6 border-b border-gray-200">
        <nav className="flex gap-1 overflow-x-auto">
          {TABS.map((t) => {
            const Icon = t.icon;
            return (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                data-testid={t.testid}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 -mb-px whitespace-nowrap transition-colors ${
                    isActive
                      ? "border-[#581C87] text-[#581C87]"
                      : "border-transparent text-gray-500 hover:text-gray-900"
                  }`
                }
              >
                <Icon className="h-4 w-4" />
                {t.label}
              </NavLink>
            );
          })}
        </nav>
      </div>

      <div className="mt-8">
        <Outlet />
      </div>
    </div>
  );
}
